import getBrowserInfo from '@/helpers/get-browser-info';

export const WIDGET_LOG = {
  INFO: 'WIDGET_INFO',
  ERROR: 'WIDGET_ERROR',
};

export const WIDGET_EVENT = {
  SUBMIT_FORM: 'SUBMIT_FORM',
  COINFLOW_3DS_CHALLENGE: 'COINFLOW_3DS_CHALLENGE',
};

const state = () => ({
  is3DsInProcess: false,
  challengeListenerCnFlow: false,
  challengeListenerTerminalId: null,
});

const mutations = {
  setIs3DsInProcess(state, payload) {
    state.is3DsInProcess = payload;
  },
  setChallengeListenerCnFlow(state, payload) {
    state.challengeListenerCnFlow = payload;
  },
  setChallengeListenerTerminalId(state, payload) {
    state.challengeListenerTerminalId = payload;
  },
};

const actions = {
  rollbackDefaultTheme({ commit, state }) {
    if (state.is3DsInProcess) commit('setIs3DsInProcess', false);
  },
  async sendLog(_store, payload) {
    try {
      await this.$axios.post(`api/v1/transactions/widget-log`, payload);
    } catch (error) {
      console.log('sendLog error', error);
    }
  },
  setChallengeListenerCnFlow({ commit }, payload) {
    commit('setChallengeListenerCnFlow', payload);
  },
  async sendChallengeCnFlowStatus(_store, { uuid, terminalId, payload }) {
    try {
      const response = await this.$axios.post(
        `api/v1/transactions/processing/threeds/${uuid}`,
        {
          payload,
          terminalId,
          browser: await getBrowserInfo(),
        },
      );

      return response;
    } catch (error) {
      console.log('sendChallengeCnFlowStatus error', error);
    }
  },
  async setChallengeListenerTerminalId({ commit }, payload) {
    commit('setChallengeListenerTerminalId', payload);
  },
};

export default {
  state,
  actions,
  mutations,
};
